import { FormattedMessage } from 'react-intl';
import { cn } from 'utils/cn';
import { ChangeChip, Headline, KpiFormProps, TargetStrip } from './KpiParts';

/**
 * One figure: the number, how it moved against the period before and, with a target, how far towards it. A view's
 * row count says what it counts, and one that stopped at its list's cap says so in place of the target, which a
 * count of unknown size cannot be measured against. The card has room for one line under the figure: the target's or
 * the cap's where there is one, and otherwise the comparison's, which goes there when the figure's line is too short
 * for both.
 */
export function NumberForm({ definition, figure, links, format, capped }: KpiFormProps) {
    const hasLineBelow = capped || Boolean(definition.target);
    return (
        <>
            <div
                className={cn(
                    'flex min-h-8 min-w-0 flex-1 items-center gap-x-2',
                    !hasLineBelow && 'flex-wrap content-center'
                )}
            >
                <Headline value={figure.value} format={format} to={links?.list} capped={capped} />
                {definition.source === 'SAVED_VIEW' && definition.show === 'COUNT' ? (
                    <span className="text-muted-foreground text-caption">
                        <FormattedMessage id="home.widgets.rows" />
                    </span>
                ) : null}
                <ChangeChip figure={figure} period={definition.period} />
            </div>
            {capped ? (
                <span className="text-muted-foreground text-caption truncate">
                    <FormattedMessage id="home.widgets.state.capped" values={{ limit: format(figure.value) }} />
                </span>
            ) : definition.target ? (
                <TargetStrip figure={figure} target={definition.target} format={format} />
            ) : null}
        </>
    );
}
